import { computed } from "vue";

import { useReadinessEmployeeViewState } from "@/views/ReadinessEmployees/composables/useReadinessEmployeeViewState";
import { useReadinessEmployees } from "@/composables/readinessEmployees/useReadinessEmployees";
import { useEmployees } from "@/composables/employees/useEmployees";

export function useTableConfig() {
  const viewState = useReadinessEmployeeViewState();
  const employees = useEmployees();
  const employee = useReadinessEmployees();
  const accountID = JSON.parse(localStorage.getItem("currentAccountID"));

  const tableParams = computed(() => {
    return {
      headers: [
        {
          text: "Employee",
          sortable: true,
          value: "first_name",
        },
        {
          text: "Readiness",
          sortable: true,
          value: "readiness",
        },
        {
          text: "Primary",
          sortable: false,
          value: "primary",
          img: "icons/briefcase.svg",
        },
        {
          text: "Preparing for",
          sortable: false,
          value: "prepares",
          img: "icons/preparing.svg",
          centerField: true,
        },
        {
          text: "Exclude from Average",
          sortable: false,
          value: "average",
          width: "120px",
          wordBreak: true,
          centerField: true,
        },
        {
          text: "",
          sortable: false,
          value: "chatter",
          width: "70px",
        },
      ],
      columns: [
        {
          field: "",
          component: "EmployeeCard",
          props: (item) => ({
            class: "my-4",
            ...viewState.getEmployeeCardProps(item),
          }),
          events: (item) => ({
            "update:availability": async (availabilityValue) => {
              const payload = {
                employee: item,
                value: availabilityValue,
              };
              await employee.onUpdateAvailability({
                accountId: accountID,
                data: payload,
              });
              await employee.loadAllEmployees();
            },
          }),
        },
        {
          field: "",
          component: "EmployeeReadinessBar",
          props: (item) => ({
            class: "my-4",
            ...viewState.getEmployeeReadinessProps(item),
          }),
        },
        {
          field: "",
          component: "EmployeeReadinessBar1",
          props: (item) => ({
            class: "my-4",
            ...viewState.getEmployeePrimaryReadinessProps(item),
          }),
        },
        {
          field: "",
          component: "EmployeeReadinessBar2",
          props: (item) => ({
            class: "my-4",
            ...viewState.getEmployeePrepareReadinessProps(item),
          }),
        },
        {
          field: "",
          component: "SwitchButton",
          props: (item) => ({
            class: "my-4",
            ...viewState.getSwitcherProps(item),
          }),
          events: (item) => ({
            onChange: async (value) => {
              viewState.updateEmployeeExcludeFromAvgValue(item, value);
            },
          }),
        },
        {
          field: "",
          component: "ChatterButton",
          props: () => ({
            class: "my-4",
          }),
          events: (item) => ({
            onClick: () => {
              employees.setCurrentEmployee(item);
              viewState.openEmployeeChatterModal();
            },
          }),
        },
      ],
      filters: {
        values: viewState.state.filters.values,
        searchText: viewState.state.filters.searchText,
      },
      hideTopSection: true,
      hideActiveNo: false,
      activeRecords: {
        field: "status",
        value: "active",
      },
      actionLabel: "Recalculate All",
      showActionButton: true,
      must: viewState.state.filters.needsRecalculation ? true : false,
      hideGridView: true,
      hideButtonIcon: true,
      title: "Employees Readiness",
      hideButtonInMessage: true,
      getRowStyle: (item) => ({
        backgroundColor:
          item.primary_position?.status === "active" ? "#FFFFFF" : "#FFFFFF",
      }),
    };
  });
  return {
    tableParams,
  };
}
